import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Tab } from '../../api/configsApi';
import { UserSettings } from '../../api/userSettingsApi';

const initialState: UserSettings = {
  defaultTab: Tab.Cases,
  defaultConfigId: null
};

const userSettingsSlice = createSlice({
  name: 'userSettings',
  initialState,
  reducers: {
    setUserSettings: (state, action: PayloadAction<UserSettings>) => {
      state.defaultTab = action.payload.defaultTab;
      state.defaultConfigId = action.payload.defaultConfigId;
    }
  }
});

export const { setUserSettings } = userSettingsSlice.actions;

export default userSettingsSlice.reducer;
